// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MM_api_ui = require("./MM_api_ui.res.js");
var MM_api_macros = require("./MM_api_macros.res.js");

var make = React.memo(function (props) {
      var modalRef = props.modalRef;
      React.useEffect((function () {
              MM_api_ui.initUiApi(modalRef);
              MM_api_macros.initMacroApi();
            }), []);
      return null;
    });

exports.make = make;
/* make Not a pure module */
